import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AwardsService } from '../services';
import { awardsKeys } from '../queryKeys';

export const useUpdateCycle = (options = {}) => {
  const { onSuccess, onError } = options;
  const queryClient = useQueryClient();

  return useMutation({
    meta: { skipGlobalErrorToaster: true },
    mutationFn: ({ cycleId, payload }) =>
      AwardsService.updateCycle(cycleId, payload),
    onSuccess: (cycle) => {
      // awardsKeys.all is ['awards'], and invalidateQueries prefix-matches, so
      // this already covers the cycles list, the individual cycle, and its
      // memberships — no need to invalidate the cycle key separately.
      queryClient.invalidateQueries({ queryKey: awardsKeys.all });
      onSuccess?.(cycle);
    },
    onError,
  });
};
